import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  jobStatusStep: 0,
  userRole: "",
  jobStatusSteps: [
    {
      label: "Quote Summary",
      value: "forRevision",
      componentName: "QuoteSummary",
    },
    {
      label: "Approved",
      value: "approved",
      componentName: "JobApproved",
    },
    {
      label: "Scheduled",
      value: "scheduled",
      componentName: "JobScheduled",
    },
    {
      label: "In Progress",
      value: "inProgress",
      componentName: "JobInProgress",
    },
    {
      label: "Completed",
      value: "completed",
      componentName: "JobCompleted",
    },
    {
      label: "Cancelled",
      value: "cancelled",
      componentName: null,
    },

    {
      label: "Support",
      value: "support",
      componentName: null,
    },
  ],
  jobData: [],
  loading: false,
  error: null,
};

export const jobSummarySlice = createSlice({
  name: "jobSummary",
  initialState,
  reducers: {
    setJobStatusStep: (state, action) => {
      state.jobStatusStep = action.payload;
    },
    setJobStatusSteps: (state, action) => {
      state.jobStatusSteps = action.payload;
    },
    setJobSummary: (state, action) => {
      state.jobData = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearJobSummary: (state) => {
      state.jobData = null;
      state.loading = false;
      state.error = null;
    },
    setUserRole: (state, action) => {
      state.userRole = action.payload;
    },
  },
});

export const { setJobStatusStep, setJobStatusSteps, setJobSummary, setLoading, setError, clearJobSummary, setUserRole } = jobSummarySlice.actions;

export const selectJobSummary = (state) => state.jobSummaryState.jobData;
export const selectJobSummaryLoading = (state) => state.jobSummaryState.loading;
export const selectJobSummaryError = (state) => state.jobSummaryState.error;

export default jobSummarySlice.reducer;
